import { useTranslation } from 'react-i18next';

const CARDS = [0, 1, 2, 3] as const;

/** Placeholder flight cards shown while a search is in flight. */
export function FlightResultsSkeleton() {
  const { t } = useTranslation();

  return (
    <div className="flight-skeleton" role="status" aria-live="polite" aria-busy="true">
      <p className="flight-skeleton__status">
        <span className="flight-skeleton__mark" aria-hidden="true" />
        {t('common.searchingFlights')}
      </p>
      <div className="flight-results">
        {CARDS.map((card) => (
          <article
            key={card}
            className="flight-skeleton__card"
            style={{ animationDelay: `${card * 90}ms` }}
            aria-hidden="true"
          >
            <div className="flight-skeleton__main">
              <div className="flight-skeleton__meta">
                <Bone w="5.5rem" />
                <Bone w="4.2rem" />
                <Bone w="3.2rem" className="flight-skeleton__badge" />
              </div>
              <div className="flight-skeleton__route">
                <div className="flight-skeleton__point">
                  <Bone w="4.6rem" h="1.7rem" />
                  <Bone w="3.4rem" />
                </div>
                <div className="flight-skeleton__path">
                  <Bone w="4.5rem" h="0.55rem" />
                  <span className="flight-skeleton__line" />
                  <Bone w="3.2rem" h="0.55rem" />
                </div>
                <div className="flight-skeleton__point flight-skeleton__point--end">
                  <Bone w="4.6rem" h="1.7rem" />
                  <Bone w="3.4rem" />
                </div>
              </div>
            </div>
            <div className="flight-skeleton__fare">
              <Bone w="7rem" h="1.35rem" />
              <Bone w="5rem" />
              <Bone w="100%" h="2.6rem" className="flight-skeleton__cta" />
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}

function Bone({ w, h = '0.72rem', className = '' }: { w: string; h?: string; className?: string }) {
  return <span className={`sk ${className}`.trim()} style={{ width: w, height: h }} />;
}
